const RECAPTCHA_PUBLIC_KEY =
  typeof window !== 'undefined' ? window.RECAPTCHA_PUBLIC_KEY : null;

export const URLS = {
  wistia: 'https://fast.wistia.com/assets/external/E-v1.js',
  recaptha: RECAPTCHA_PUBLIC_KEY
    ? `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_PUBLIC_KEY}`
    : '',
  stripev2: 'https://js.stripe.com/v2/',
  paypal: 'https://www.paypalobjects.com/api/checkout.js',
  conekta: 'https://cdn.conekta.io/js/latest/conekta.js',
  ebanx: 'https://js.ebanx.com/ebanx-libjs-latest.min.js',
  vidyard: 'https://play.vidyard.com/embed/v4.js',
  payu: 'https://gateway.payulatam.com/ppp-web-gateway/javascript/PayU.js',
  youtube: 'https://www.youtube.com/iframe_api',
};

const scriptsLoadedCache: string[] = [];

function loadScript({
  src,
  done,
  async,
}: {
  src: string;
  done?: any;
  async?: boolean;
}) {
  return new Promise((resolve, reject) => {
    // check if it has already loaded
    if (scriptsLoadedCache.includes(src)) {
      resolve(true);
    } else {
      const js = document.createElement('script');

      js.src = src;
      js.type = 'text/javascript';
      if (async) {
        js.async = true;
      }

      // set the callbacks before insert the script tag in the document
      js.onload = () => {
        resolve(true);
        scriptsLoadedCache.push(src);
      };
      js.onerror = reject;

      document.head.appendChild(js);
    }
  });
}

export default loadScript;
